import { Injectable } from '@angular/core';
import { MemberCardStore } from './member-card.store';
import { MemberCard, wipeBalance } from './member-card.model';
import { ApiService } from '../../shared/services/core/api.service';
import { tap, mapTo, map } from 'rxjs/operators';
import { BalanceStore } from '../balance/balance.store';
import { Balance } from '../balance/balance.model';
import { iif } from 'rxjs';
import { MemberQuery } from '../member/member.query';
import { LoggingService } from '../../shared/services/core/logging.service';
import { MemberCardQuery } from './member-card.query';

@Injectable({ providedIn: 'root' })
export class MemberCardService {
  constructor(
    private memberCardStore: MemberCardStore,
    private balanceStore: BalanceStore,
    private api: ApiService,
    private memberQuery: MemberQuery,
    private loggingService: LoggingService,
    private memberCardQuery: MemberCardQuery,
  ) {}

  /** put cards into the store. Will retrieve balances if purse number is included */
  fetchCards(purse?: number) {
    let withoutBalance = this.api.get<MemberCard>('cards').pipe(tap(this.memberCardStore.upsertMany));

    let withBalance = this.api.get<MemberCard>('cards/withbalance/' + purse).pipe(
      tap(cards => {
        // update the balances
        let balances = cards.map(
          card => ({ purseId: purse, memberId: card.MemberId, balance: card.AvailableBalance } as Balance)
        );
        this.balanceStore.upsertMany(balances);
      }),
      map(cards => cards.map(card => wipeBalance(card))),
      tap(cards => this.memberCardStore.upsertMany(cards))
    );
    return iif(() => !!purse, withBalance, withoutBalance).pipe(mapTo('from server'));
  }

  setProductCode(productCode: string) {
    this.memberCardStore.update(this.memberQuery.getUserContext().memberId, entity => ({ ...entity, ProductCode: productCode }));
  }

  clearCacheAndFetchNewCards(){
    this.memberCardStore.setHasCache(false);
    this.fetchCards().toPromise();
  }

  /** get a single card from the store. will update balance if purse is specified. without memberId will default to current user's card */
  fetchCard(purse?: number, memberId?: string) {
    memberId = memberId || this.memberQuery.getUserContext().memberId;

    let card$ = this.api.getAnySingle<MemberCard>(`Members/${memberId}/card/${purse || 1}`).pipe(
      tap(card => {
        if (card == null) {
          this.loggingService.error('null MemberCard returned from API')
        } else {
          this.memberCardStore.remove(this.memberCardQuery.getAll().map(x=>x.MemberId));
          this.memberCardStore.upsert(memberId, card);
        } 
      })
    );

    if (purse) {
      card$ = card$.pipe(tap(card => this.balanceStore.update([memberId, purse].join('-'), { balance: card.AvailableBalance })));
    }

    return card$.pipe(mapTo(null));
  }
}
